import React from "react";
import logo from "../assests/Images/PPT_Logo.png";
import { FaFacebookF } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa";
import { FaPinterestP } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { ImChrome } from "react-icons/im";

const Footer = () => {
  return (
    <>
      <footer className="border-t border-gray-300 bg-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="flex flex-col gap-6">
            <img
              src={logo}
              alt="People Process Teck Logo"
              className="max-w-[180px]"
            />

            <ul className="flex gap-4">
              {[
                {
                  icon: <FaFacebookF />,
                  link: "https://www.facebook.com/People-Process-Teck-107687647677620",
                },
                {
                  icon: <FaLinkedinIn />,
                  link: "https://www.linkedin.com/company/people-process-teck-1/",
                },
                {
                  icon: <FaInstagram />,
                  link: "https://www.instagram.com/peopleprocessteck/",
                }
                // ,
                // {
                //   icon: <FaPinterestP />,
                //   link: "https://in.pinterest.com/peopleprocessteck/",
                // },
                // { icon: <FaTwitter />, link: "https://x.com/PeopleProcessTk" },
              ].map((item, idx) => (
                <li key={idx}>
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                    className="w-10 h-10 flex items-center justify-center rounded-full
                         bg-primary text-white hover:bg-primary/80 transition"
                  >
                    {item.icon}
                  </a>
                </li>
              ))}
            </ul>

            <div className="pt-4 border-t border-gray-300">
              <p className="text-gray-600 text-m">Our Location</p>
              <p className="font-semibold text-gray-700 text-m leading-relaxed">
                4C-209, 2nd Floor, 4th Cross, East of NEGF, Kasturi Nagar,
                Bengaluru – 560043
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="text-2xl font-bold text-primary">Quick Links</h4>

            <ul className="space-y-2 text-gray-700 text-m">
              <li>
                <a href="/apply-now" target="_blank" className="hover:text-primary">
                  Apply for Jobs
                </a>
              </li>
              <li>
                <a
                  href="https://www.grcpulse.in/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-primary"
                >
                  GRC Pulse
                </a>
              </li>
              <li>
                <a href="https://indigistechk.com/" target="_blank" className="hover:text-primary">
                 Indigis
                </a>
              </li>
              <li>
                <a href="https://gigleji.com/" target="_blank" className="hover:text-primary">
                 Gigleji
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="text-2xl font-bold text-primary">Connect</h4>

            <div className="flex items-center gap-3 text-m text-gray-700">
              <FaPhoneAlt />
              <a href="tel:+919972398341">+91 99723 98341</a>
            </div>

            <div className="flex items-center gap-3 text-m text-gray-700">
              <FaPhoneAlt />
              <a href="tel:+919686601696">+91 96866 01696</a>
            </div>

            <div className="flex items-center gap-3 text-m text-gray-700">
              <IoMdMail />
              <a href="mailto:contact@peopleprocessteck.com">
                contact@peopleprocessteck.com
              </a>
            </div>
          </div>
        </div>

        <div className="bg-gray-200 py-4 text-center text-sm text-gray-600">
          © 2024 People Process Teck. All Rights Reserved.
        </div>
      </footer>

      {/* <div className='bg-gray-200 flex flex-col justify-start items-center  lg:pr-5 space-y-2 border border-t-slate-700 p-5'>
        <h1 className='text-3xl text-red-700 font-bold'>NEWSLETTER</h1>
        <p>Join our subscribers list to get the latest news and notifications.</p>
        <div className='w-full px-3'>
          <input type='email' placeholder='Enter your email address here... ' required className='mx-auto flex justify-center items-center w-[50%]  p-4 rounded-full' />
          <button className="mt-6 mx-auto flex justify-center items-center text-center lg:text-left bg-primary  text-sm text-white outline outline-2 outline-white p-2 rounded-2xl">Subscribe Now</button>
        </div>
        <h1>© 2024 People Process Teck.  All Rights Reserved.</h1>
      </div> */}
    </>
  );
};

export default Footer;
